import { render, staticRenderFns } from "./BlockNavigation.html?vue&type=template&id=33f9bb39&"
import script from "./BlockNavigation.vue?vue&type=script&lang=js&"
export * from "./BlockNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BlockNavigation.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports